import React, { useState, useRef, useEffect } from "react";
import Icon from "../../assets/icons/Icon";

const ConfirmBox = ({ title, text, onConfirm, onCancel,primaryBtnName,hideButton }) => {
  const modalRef = useRef(null); // Ref for the modal container

  useEffect(() => {
    // Close modal when clicking outside of the modal
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onCancel(); // Close the modal if clicked outside
      }
    };

    // Add event listener on mount
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onCancel]);

  return (
    <div className="fixed inset-0 bg-[#02080E80]  flex justify-center items-center z-50">
      <div
        ref={modalRef}
        className="bg-white p-8 rounded-lg shadow-xl w-96 relative"
      >
     
        <span onClick={onCancel} className="w-7 cursor-pointer absolute top-2 right-2 text-(--list-item-gray) hover:text-gray-900"><Icon type="remove"/></span>
    

        {/* Title */}
        <h2 className="text-xl font-bold text-center text-gray-800">
          {title || "Are you sure?"}
        </h2>

        {/* Description */}
        <p className="text-gray-600 text-center mt-3 ">
          {text || "This action cannot be undone."}
        </p>

        {/* Button Container */}
       {!hideButton && <div className="flex justify-center gap-4 mt-6">
          {/* Cancel Button */}
          <button
            onClick={onCancel}
            className="bg-gray-300  text-gray-700 py-2 px-6 rounded-lg shadow-lg hover:bg-gray-400 transition duration-300"
          >
            Cancel
          </button>

          {/* Confirm Button */}
          <button
            onClick={onConfirm}
            className="bg-green-600 text-white  py-2 px-6 rounded-lg shadow-lg hover:bg-green-700 transition duration-300"
          >
            {primaryBtnName || "Delete"}
          </button>
        </div>}
      </div>
    </div>
  );
};

export default ConfirmBox;
